import {
  ArrowDropUp as ArrowDropUpIcon,
  ArrowDropDown as ArrowDropDownIcon,
} from '@mui/icons-material';

export const getIconPanelGateProps = (value: number, oldValue: number) => {
  const clampPercent = (value: number) => Math.round(Math.max(-1000, Math.min(1000, value)));
  const subValueLeft = clampPercent(
    oldValue === 0 ? (value === 0 ? 0 : 100) : ((value - oldValue) / oldValue) * 100,
  );
  const subValueIcon = subValueLeft >= 0 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
  return { subValueLeft, subValueIcon };
};

export const forecastValuesByTrend = (values: number[], days: number) => {
  if (!values.length) return Array.from({ length: days }, () => 0);
  if (values.length === 1) return Array.from({ length: days }, () => values[0]);

  const xAverage = (values.length - 1) / 2;
  const yAverage = values.reduce((sum, value) => sum + value, 0) / values.length;
  const trend =
    values.reduce((sum, value, index) => sum + (index - xAverage) * (value - yAverage), 0) /
    values.reduce((sum, _, index) => sum + (index - xAverage) ** 2, 0);
  const startValue = yAverage - trend * xAverage;

  return Array.from({ length: days }, (_, index) =>
    Math.max(0, Math.round(startValue + trend * (values.length + index))),
  );
};
